import React, { useEffect, useState } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  CustomDataTableHeader,
  PageHeader,
  CustomPanel,
  CustomCheckbox,
  CustomMultiSelect,
} from '../../../../components'
import { withRouter } from 'react-router-dom'
import {
  roteirizacaoAssociarEntregas,
  roteirizacaoGetEntregas,
} from '../../../../services/api/https/deliveries/roteirizacao-previa.http'
import { connect } from 'react-redux'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import { getDeliveriesCyclesByIds } from '../../../../services/api/https/deliveries/delivery-cycle.http'

const RoteirizacaoAssocEntregas = ({ history, dispatch }) => {
  // Constants
  const { roteirizacao } = history.location.state

  // Hooks
  const [globalFilter, setGlobalFilter] = useState('')
  const [entregas, setEntregas] = useState([])
  const [selecionarTodos, setSelecionarTodos] = useState(false)
  const [deliveriesCycles, setDeliveriesCycles] = useState([])
  const [filterByCycle, setFilterByCycle] = useState(false)
  const [selectedCycle, setSelectedCycles] = useState([])
  const [empresas, setEmpresas] = useState([])
  const [empresasSelecionadas, setEmpresasSelecionadas] = useState([])

  useEffect(() => {
    async function fetchEntregas() {
      try {
        dispatch(showLoadingBox('Carregando as entregas ...', 'Aguarde'))
        const savedEntregas = await roteirizacaoGetEntregas(roteirizacao.id)
        const cyclesIds = savedEntregas.map(e => e.cycle_id)
        if (cyclesIds.length) {
          const deliveriesCycle = await getDeliveriesCyclesByIds(Array.from(new Set(cyclesIds)))
          setDeliveriesCycles(deliveriesCycle)
        }
        setEntregas(savedEntregas)
        setEmpresas(
          Array.from(new Set(savedEntregas.map(e => e.companyName))).map(s => ({
            value: s,
            label: s,
          })),
        )
        setEmpresasSelecionadas(
          Array.from(new Set(savedEntregas.filter(e => e.selected).map(e => e.companyName))),
        )
      } catch (error) {
        dispatch(showMessageBox(null, errorHandler(error)))
      } finally {
        dispatch(hideLoadingBox())
      }
    }
    fetchEntregas()
  }, [])

  // Events
  const onCheckBoxRowClicked = entrega => {
    const index = entregas.findIndex(e => e.delivery_id === entrega.delivery_id)
    if (index !== -1) {
      setEntregas(prev => {
        prev[index].selected = !prev[index].selected
        return [...prev]
      })
    }
  }
  const onSalvarClicked = async () => {
    try {
      dispatch(showLoadingBox('Salvando as associações ...', 'Aguarde'))
      await roteirizacaoAssociarEntregas(roteirizacao.id, entregas)
      dispatch(showMessageBox('Operação realizada com sucesso', null))
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      dispatch(hideLoadingBox())
    }
  }
  const onSelecionarTodos = () => {
    setSelecionarTodos(!selecionarTodos)
    setEntregas(prev => {
      return prev.map(p => ({ ...p, selected: !selecionarTodos }))
    })
  }
  const onSelecaoPorEmpresaChange = values => {
    setEmpresasSelecionadas(values)
    if (Array.isArray(values)) {
      const _entregas = [...entregas]
      _entregas.forEach(e => {
        const index = values.findIndex(v => v === e.companyName)
        if (index !== -1) e.selected = true
        else e.selected = false
      })
      setEntregas(_entregas)
    }
  }
  const onSelecaoPorCicloChange = values => {
    setSelectedCycles(values)
    if (Array.isArray(values)) {
      const _entregas = [...entregas]
      _entregas.forEach(e => {
        const index = values.findIndex(v => v === e.cycle_id)
        if (index !== -1) e.selected = true
        else e.selected = false
      })
      setEntregas(_entregas)
    }
  }
  // Render
  return (
    <>
      <PageHeader>Roteirização - Associação das Entregas</PageHeader>
      <div style={{ marginTop: 25 }}>
        <CustomPanel
          showBtnNovo
          btnLabel="Salvar"
          onNovo={onSalvarClicked}
          onVoltar={history.goBack}
        >
          <div className="p-grid">
            <div className="p-col-3" style={{ paddingTop: 25 }}>
              <CustomCheckbox
                checked={selecionarTodos}
                onChange={value => onSelecionarTodos(value)}
              >
                Selecionar Todos
              </CustomCheckbox>
            </div>
            <div className="p-grid p-col-9">
              <div className="p-col-fixed" style={{ paddingTop: 25 }}>
                <CustomCheckbox
                  checked={filterByCycle}
                  onChange={value => setFilterByCycle(!filterByCycle)}
                >
                  Filtrar por Ciclo de Entrega
                </CustomCheckbox>
              </div>
              <div className="p-col-4">
                {filterByCycle ? (
                  <CustomMultiSelect
                    label={'Seleção Por Ciclo de Entrega'}
                    filter={true}
                    onChange={onSelecaoPorCicloChange}
                    value={selectedCycle}
                    options={deliveriesCycles.map(dc => ({
                      ...dc,
                      value: dc.id,
                      label: `${dc.id} - ${dc.name}`,
                    }))}
                    marginTop={0}
                  />
                ) : (
                  <CustomMultiSelect
                    label={'Seleção Por Empresa'}
                    filter={false}
                    onChange={onSelecaoPorEmpresaChange}
                    value={empresasSelecionadas}
                    options={empresas}
                    marginTop={0}
                  />
                )}
              </div>
            </div>
            <div className="p-col-12">
              <DataTable
                value={entregas}
                emptyMessage={'Nenhuma Entrega Encontrada'}
                globalFilter={globalFilter}
                header={<CustomDataTableHeader onChange={value => setGlobalFilter(value)} />}
                paginator={true}
                rows={20}
              >
                <Column
                  field="selected"
                  style={tableCellCentered(50)}
                  body={entrega => (
                    <CustomCheckbox
                      checked={entrega.selected}
                      onChange={() => onCheckBoxRowClicked(entrega)}
                    />
                  )}
                />
                <Column
                  field={'identifier'}
                  header={'Identificador'}
                  style={tableCellCentered(150)}
                />
                <Column field={'nomeFantasia'} header={'Cliente'} />
                <Column field={'companyName'} header={'Empresa'} style={tableCellCentered(200)} />
                <Column field={'qteCaixas'} header={'Qte Caixas'} style={tableCellCentered(100)} />
                <Column
                  field={'placa_prevista_carregamento'}
                  header={'Placa Prevista'}
                  style={tableCellCentered(200)}
                />
                <Column field={'status'} header={'Status'} style={tableCellCentered(200)} />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
    </>
  )
}

export default connect()(withRouter(RoteirizacaoAssocEntregas))
